var productImageSlider = function () {
  $(".slider_images").slick({
    centerMode: !0,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 7e3,
    autoplay: !0,
    autoplaySpeed: 0,
    infinite: !0,
    cssEase: "linear",
    arrows: !1,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
    ],
  });
};

productImageSlider();
$(document).on("shopify:section:load", function (event) {
productImageSlider();
});
